<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#FF1313" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-dialog v-model="cancelDialogue" width="400">
      <v-card>
        <v-layout pa-4 wrap justify-center>
          <v-flex xs12>
            <span
              style="
                color: #000000;
                font-family: opensanssemibold;
                font-size: 18px;
              "
            >
              Do you want to cancel this product ?
            </span>
          </v-flex>
          <v-flex xs12>
            <span
              style="
                color: #000000;
                font-family: opensanssemibold;
                font-size: 14px;
              "
            >
              {{ storage.product.productname }}
            </span>
          </v-flex>
          <v-flex xs6 px-2>
            <v-btn
              tile
              block
              depressed
              dark
              color="#ff1313"
              @click="cancelProduct"
            >
              <span style="font-family: poppinsregular; font-size: 14px">
                Yes
              </span>
            </v-btn>
          </v-flex>
          <v-flex xs6 px-2>
            <v-btn
              tile
              block
              depressed
              dark
              color="#1BD93B"
              @click="cancelDialogue = false"
            >
              <span style="font-family: poppinsregular; font-size: 14px">
                No
              </span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-layout wrap justify-center>
      <v-flex xs12>
        <v-layout wrap justify-center>
          <v-flex xs12 sm2 pr-1 py-1>
            <v-img
              :src="baseURL + '/u/' + storage.product.photos[0]"
              height="100px"
              contain
            >
              <template v-slot:placeholder> <ImageLoader /> </template>
            </v-img>
          </v-flex>
          <v-flex xs12 sm8 pl-2>
            <v-layout wrap justify-center>
              <v-flex xs12 text-left>
                <router-link
                  :to="
                    '/Products/' +
                    storage.product.productname +
                    '/' +
                    storage.product._id
                  "
                >
                  <span
                    style="
                      font-family: poppinslight;
                      font-size: 15px;
                      color: #000000;
                    "
                  >
                    {{ storage.product.productname }}
                  </span>
                </router-link>
              </v-flex>
              <v-flex xs12 text-left pt-2>
                <v-layout wrap justify-center>
                  <v-flex xs3>
                    <v-layout wrap justify-center>
                      <v-flex xs12 text-left>
                        <span
                          style="
                            font-family: opensanssemibold;
                            font-size: 14px;
                            color: #8d8d8d;
                          "
                        >
                          Price
                        </span>
                      </v-flex>
                      <v-flex xs12 text-left>
                        <span
                          style="
                            font-family: opensanssemibold;
                            font-size: 18px;
                            color: #000000;
                          "
                        >
                          {{ storage.price }}
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs3>
                    <v-layout wrap justify-center>
                      <v-flex xs12 text-left>
                        <span
                          style="
                            font-family: opensanssemibold;
                            font-size: 14px;
                            color: #8d8d8d;
                          "
                        >
                          Offer
                        </span>
                      </v-flex>
                      <v-flex xs12 text-left>
                        <span
                          style="
                            font-family: opensanssemibold;
                            font-size: 18px;
                            color: #000000;
                          "
                        >
                          {{ storage.offerpercentage }} %
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs3>
                    <v-layout wrap justify-center>
                      <v-flex xs12 text-left>
                        <span
                          style="
                            font-family: opensanssemibold;
                            font-size: 14px;
                            color: #8d8d8d;
                          "
                        >
                          Size
                        </span>
                      </v-flex>
                      <v-flex xs12 text-left>
                        <span
                          style="
                            font-family: opensanssemibold;
                            font-size: 18px;
                            color: #000000;
                          "
                        >
                          {{ storage.size }}
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs3>
                    <v-layout wrap justify-center>
                      <v-flex xs12 text-left>
                        <span
                          style="
                            font-family: opensanssemibold;
                            font-size: 14px;
                            color: #8d8d8d;
                          "
                        >
                          Color
                        </span>
                      </v-flex>
                      <v-flex xs12 text-left>
                        <v-avatar :color="storage.color" size="25" />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex
            xs12
            sm2
            :align-self-end="
              storage.deliverystatus == 'Delivered' ? false : true
            "
          >
            <v-btn
              v-if="
                storage.deliverystatus != 'Cancelled' &&
                storage.deliverystatus != 'Delivered' &&
                order.purchasetype == 'Normal'
              "
              :ripple="false"
              depressed
              dark
              block
              tile
              color="#FF1313"
              @click="cancelDialogue = true"
            >
              Cancel
            </v-btn>
            <br />
            <v-select
              disabled
              outlined
              dense
              color="#FF1313"
              placeholder="Status"
              v-model="storage.deliverystatus"
              :items="orderStatuses"
              item-text="name"
              item-value="value"
              item-color="#FF1313"
              hide-details
              v-on:input="subSize(product.subcategory)"
            >
              <template v-slot:item="{ item }">
                <span class="text-left">
                  {{ item.name }}
                </span>
              </template>
            </v-select>
            <br v-if="storage.deliverystatus == 'Delivered'" />
            <v-sheet
              v-if="storage.deliverystatus == 'Delivered'"
              outlined
              color="#70707029"
              rounded
            >
              <v-card
                :href="
                  baseURL +
                  '/Purchase/printreceipt?id=' +
                  order._id +
                  '&productid=' +
                  storage.product._id
                "
                flat
                color="#F5F7FC"
                height="40px"
              >
                <v-layout wrap justify-center fill-height>
                  <v-flex xs12 align-self-center>
                    <span
                      style="
                        font-family: opensansbold;
                        font-size: 14px;
                        color: #1fb13b;
                      "
                    >
                      PRINT RECEIPT
                    </span>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-sheet>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: ["storage", "order"],
  data() {
    return {
      appLoading: false,
      timeout: 5000,
      msg: "",
      ServerError: false,
      showSnackBar: false,
      orderStatus: "Placed",
      orderStatuses: [
        { name: "Placed", value: "Placed" },
        { name: "Cancel", value: "Cancel" },
        { name: "Shipped", value: "Shipped" },
        { name: "In Transit", value: "In Transit" },
        { name: "Delivered", value: "Delivered" },
        { name: "Cancelled", value: "Cancelled" },
        { name: "Return", value: "Return" },
      ],
      cancelDialogue: false,
    };
  },
  methods: {
    cancelProduct() {
      this.$emit("stepper", {
        type: "cancell",
        product: this.storage,
        transactionid: this.order._id,
      });
      this.cancelDialogue = false;
    },
  },
};
</script>